import React, { useState } from "react";
import Video from '../../../../assest/farmstay/v1.mp4'
import image from '../../../../assest/farmstay/33.jpeg'
import './videowalkthrough.scss'

const VideoWalkthrough = () =>
{

	const [play, setPlay] = useState(false);

	return (
		<div className="video-walkthrough">
			<h2>Watch Farm Stay Tour</h2>

			<div className="video-container">

				{play ? (
					// <video src={Video} autoPlay controls />
					<iframe
						className="VideoWalkthrough-video-frame"
						src={Video}
						title="Video"
						style={{ border: "none" }}
						allowFullScreen={true}
					/>
				) : (
					<>
						<img
							src={image}
							alt="video"
						/>

						<div className="video-play-overlay" onClick={() => setPlay(true)}>
							<button className="play-btn">▶</button>
							<h2>Explore the Stay</h2>
						</div>
					</>
				)}

			</div>
		</div>
	);
};

export default VideoWalkthrough;